

/*
vim: fileformat=unix syntax=JavaScript tabstop=4 shiftwidth=4 expandtab fileencoding=utf8
*/
/* jslint browser: true */

//warning!! this file is also shared and used inside demo page, see uniwizard-lib.js
//be careful when changing
import $ from 'jquery';

import { getTranslator } from '../js/i18n';
import utils from './utils';

const t = getTranslator();

export default function MouseHandler(signer, processButtonsOnly) {
    const self = this;
    // The isDown flag is used like this:
    // 0 = up
    // +ve = down, pressed on button number
    // -1 = down, inking
    // -2 = down, ignoring
    let m_isDown = null;

    let m_penData = null; // Array of data being stored. This can be subsequently used as desired.
    let m_btns = null; // The array of buttons that we are emulating.
    const m_signer = signer;
    const m_processButtonsOnly = processButtonsOnly;
    let m_ctx = null;
    let m_width = null;
    let m_height = null;
    let m_pointerType = null;
    let m_allowedMask = null;
    const m_pointerMask = {
        mouse: utils.FILTER_MOUSE,
        pen: utils.FILTER_PEN,
        touch: utils.FILTER_TOUCH,
    };

    let cleanupEventListeners = [];

    function checkButtonPressed(pt) {
        let btn = 0; // will be +ve if the pen is over a button.
        for(let i = 0; i < m_btns.length; ++i) {
            if(m_btns[i].bounds.contains(pt)) {
                btn = i + 1;
                break;
            }
        }
        return btn;
    }

    //isDown = 0 - up, 1 - down, -1 - move
    function onCanvasPointer(evt, isDown) {
        //ignore events from other pointers, if we already started capturing one
        let pointerType = (
            (evt.pointerType === undefined)
            || (evt.pointerType === null)
            || (evt.pointerType === 'touch') // mobile devices with touch events
        ) ? 'mouse' : evt.pointerType;
        if(typeof (pointerType) !== 'string') {
            if(pointerType == 2)
                pointerType = 'touch';
            else if(pointerType == 3)
                pointerType = 'pen';
            else
                pointerType = 'mouse';
        }
        const pointerMask = m_pointerMask[pointerType];
        //if we started signing with specific pointer, listen only to it
        if((m_pointerType !== null) && (m_pointerType != pointerType))
            return;

        const targetOffset = $(evt.target).offset();
        const pt = new utils.Point(evt.pageX - targetOffset.left, evt.pageY - targetOffset.top);
        const penDataObj = { pt };
        // currently js time precision is reduced to prevent fingerprinting - stupid meltdown/spectre attack :(
        if(evt.hwTimestamp !== undefined) {
            //in microseconds => to milliseconds
            penDataObj.time = evt.hwTimestamp / 1000;
        } else if(evt.timeStamp !== undefined) {
            penDataObj.time = evt.timeStamp;
        } else {
            penDataObj.time = new Date().getTime();
        }
        let pressure = (evt.pressure === undefined) ? 0 : evt.pressure;
        if(!pressure) {
            //pressure fix
            //IE 10 and mouse events will always report pressure = 0 for mouse
            if((isDown == 1) //pen down
                    || ((m_isDown != 0) && (isDown == -1))) //pen pressed move
                pressure = 0.5;
        }
        penDataObj.pressure = pressure;

        const btn = checkButtonPressed(pt);
        if(m_isDown == 0) {
            isDown = (pressure > 0);

            if(isDown) {
                // transition to down
                if(btn > 0) {
                    // We have put the pen down on a button.
                    // Track the pen without inking on the client.

                    m_isDown = btn;
                } else if(!m_processButtonsOnly && (pointerMask & m_allowedMask)) {
                    // We have put the pen down somewhere else.
                    // Treat it as part of the signature.

                    m_isDown = -1;

                    //capture only this pointer type
                    if(m_pointerType === null) {
                        m_pointerType = pointerType;
                        m_signer.selectDevice(self, pointerMask);
                    }
                }
            }

            //we pressed pen outside button, let's capture
            //also capture pen up events, when we already captured some pen downs, as C# BioSign does
            if(((m_isDown == 0) && m_penData.length)
                    || (m_isDown == -1))
                m_penData.push(penDataObj);
        } else {
            isDown = (pressure > 0);

            // draw
            if(m_isDown == -1) {
                // Draw a line from the previous down point to this down point.
                // This is the simplist thing you can do; a more sophisticated program
                // can perform higher quality rendering than this!

                const prev = m_penData[m_penData.length - 1].pt;
                m_signer.onPenData(prev, pt, pressure);
                m_penData.push(penDataObj);
            }

            if(!isDown) {
                // transition to up
                if(btn > 0) {
                    // The pen is over a button

                    if(btn == m_isDown) {
                        // The pen was pressed down over the same button as is was lifted now.
                        // Consider that as a click!
                        setTimeout(function() {
                            m_btns[btn - 1].click();
                        }, 10);
                    }
                }
                m_isDown = 0;
            }
        }
    }
    function onCanvasPointerMove(event) {
        onCanvasPointer(event, -1);
    }
    function onCanvasPointerUp(event) {
        if(m_isDown != 0) {
            onCanvasPointer(event, 0);
        }
    }
    function onCanvasPointerDown(event) {
        if(m_isDown == 0) {
            onCanvasPointer(event, 1);
        }
    }

    function touchToMouse(event, type) {
        const touch = (event.touches && event.touches[0]) || {};
        const mouseEvent = {
            type,
            pointerType: 'touch',
            target: event.target,
            clientX: touch.clientX,
            clientY: touch.clientY,
            pageX: touch.pageX,
            pageY: touch.pageY,
            hwTimestamp: event.hwTimestamp,
            timeStamp: event.timeStamp,
            pressure: touch.force,
        };
        return mouseEvent;
    }
    function handleTouchStart(event) {
        onCanvasPointerDown(touchToMouse(event, 'pointerdown'));
    }
    function handleTouchEnd(event) {
        onCanvasPointerUp(touchToMouse(event, 'pointerup'));
    }
    function handleTouchMove(event) {
        onCanvasPointerMove(touchToMouse(event, 'pointermove'));
    }
    function preventTouchScrolling(canvas) {
        return function(event) {
            if(event.target == canvas) {
                event.preventDefault();
            }
        };
    }

    this.init = function() {
    };

    // Connect to the first device
    this.connect = function() {
        // Create the signature window.
        const wndData = m_signer.createModalWindow(true);

        m_btns = wndData.btns;
        m_ctx = wndData.ctx;
        m_width = wndData.width;
        m_height = wndData.height;
        m_allowedMask = wndData.bioDeviceMask;
        m_signer.selectDevice(self, m_allowedMask & utils.FILTER_POINTER_ALL_INTERNAL);

        const canvas = m_ctx.canvas;
        const jcanvas = $(canvas);
        let pointerBound = false;
        if(!m_processButtonsOnly) {
            //IE 11 we can use pointer events
            if(window.PointerEvent) {
                canvas.addEventListener('pointerdown', onCanvasPointerDown);
                canvas.addEventListener('pointerup', onCanvasPointerUp);
                canvas.addEventListener('pointerout', onCanvasPointerUp);
                canvas.addEventListener('pointermove', onCanvasPointerMove);

                cleanupEventListeners.push(function() {
                    canvas.removeEventListener('pointerdown', onCanvasPointerDown);
                    canvas.removeEventListener('pointerup', onCanvasPointerUp);
                    canvas.removeEventListener('pointerout', onCanvasPointerUp);
                    canvas.removeEventListener('pointermove', onCanvasPointerMove);
                });

                const ownerDocument = canvas.ownerDocument || document;
                const _preventTouchScrolling = preventTouchScrolling(canvas);
                ownerDocument.body.addEventListener('touchstart', _preventTouchScrolling, { passive: false });
                ownerDocument.body.addEventListener('touchend', _preventTouchScrolling, { passive: false });
                ownerDocument.body.addEventListener('touchmove', _preventTouchScrolling, { passive: false });

                cleanupEventListeners.push(function() {
                    ownerDocument.body.removeEventListener('touchstart', _preventTouchScrolling);
                    ownerDocument.body.removeEventListener('touchend', _preventTouchScrolling);
                    ownerDocument.body.removeEventListener('touchmove', _preventTouchScrolling);
                });

                pointerBound = true;
            //IE 10 pointer events
            } else if(window.MSPointerEvent) {
                canvas.addEventListener('MSPointerDown', onCanvasPointerDown);
                canvas.addEventListener('MSPointerUp', onCanvasPointerUp);
                canvas.addEventListener('MSPointerOut', onCanvasPointerUp);
                canvas.addEventListener('MSPointerHover', onCanvasPointerMove);
                canvas.addEventListener('MSPointerMove', onCanvasPointerMove);

                cleanupEventListeners.push(function() {
                    canvas.removeEventListener('MSPointerDown', onCanvasPointerDown);
                    canvas.removeEventListener('MSPointerUp', onCanvasPointerUp);
                    canvas.removeEventListener('MSPointerOut', onCanvasPointerUp);
                    canvas.removeEventListener('MSPointerHover', onCanvasPointerMove);
                    canvas.removeEventListener('MSPointerMove', onCanvasPointerMove);
                });

                pointerBound = true;
            }
        }

        if(!pointerBound) {
            jcanvas.mousedown(function(event) {
                onCanvasPointerDown(event);
            });
            jcanvas.mouseup(function(event) {
                onCanvasPointerUp(event);
            });
            jcanvas.mouseout(function(event) {
                onCanvasPointerUp(event);
            });

            cleanupEventListeners.push(function() {
                jcanvas.unbind('mousedown');
                jcanvas.unbind('mouseup');
                jcanvas.unbind('mouseout');
            });

            // mobile devices with touch events
            if(typeof (canvas.addEventListener) == 'function') {
                canvas.addEventListener('touchstart', handleTouchStart);
                canvas.addEventListener('touchend', handleTouchEnd);
                canvas.addEventListener('touchmove', handleTouchMove);

                cleanupEventListeners.push(function() {
                    canvas.removeEventListener('touchstart', handleTouchStart);
                    canvas.removeEventListener('touchend', handleTouchEnd);
                    canvas.removeEventListener('touchmove', handleTouchMove);
                });
            }

            if(!m_processButtonsOnly) {
                jcanvas.mousemove(function(event) {
                    onCanvasPointerMove(event);
                });

                cleanupEventListeners.push(function() {
                    jcanvas.unbind('mousemove');
                });
            }
        }
    };

    // Initialize the screen
    this.clearScreen = function() {
        m_penData = [];
        m_isDown = 0;
    };

    this.close = function() {
        for(const listener of cleanupEventListeners) {
            try {
                listener();
            } catch(e) { /**/ }
        }
        cleanupEventListeners = [];
    };

    this.makeSignatureData = function() {
        if(!m_penData || !m_penData.length)
            throw new Error(t('mouse.signature_not_collected'));

        const signatureData = {
            manufacturer: m_pointerType + '@System',
            model: m_pointerType,
            minPenTouchForce: 0,
            xPointMin: 0,
            yPointMin: 0,
            xPointMax: m_width,
            yPointMax: m_height,
            chx: null,
            chy: null,
            chpressure: null,
            chtime: null,
        };

        const timeScalingValue = 1000.0; // milliseconds
        const maxTimeValue = 65535;
        const pressureFactoreMultiplifier = 1000;
        const dotsPerInch = 96;
        const mmInOneInch = 25.4;

        const chx = {
            scale: dotsPerInch / mmInOneInch, min: null, max: null, data: [],
        };
        const chy = {
            scale: dotsPerInch / mmInOneInch, min: null, max: null, data: [],
        };
        const chpressure = {
            scale: null, min: 0, max: pressureFactoreMultiplifier, data: [],
        };
        const chtime = {
            scale: timeScalingValue, min: 0, max: maxTimeValue, data: [],
        };

        let timeFirst = null;
        for(let i = 0; i < m_penData.length; i++) {
            const penPoint = m_penData[i];
            let time;
            if(timeFirst === null) {
                time = 0;
                timeFirst = penPoint.time;
            } else {
                time = penPoint.time - timeFirst;
                if(time > maxTimeValue)
                    throw new Error(t('mouse.signature_duration_exceeded'));
            }

            chx.data.push(penPoint.pt.x);
            chy.data.push(penPoint.pt.y);
            chpressure.data.push(penPoint.pressure * pressureFactoreMultiplifier);
            chtime.data.push(time);
        }

        signatureData.chx = chx;
        signatureData.chy = chy;
        signatureData.chpressure = chpressure;
        signatureData.chtime = chtime;
        return signatureData;
    };
}
